<template>
  <div class="dashboard" id="profile"> 
    <div class="contenedor-izquierda">
      <div style="position: relative;">
        <div style="display: flex; align-items: center;">
          <h2 class="access-concessions">{{ $t('settings.accessConcessions') }}</h2>
          <button style="font-size: 16px; background: none; color: black; padding: 0;" @click="showInfo" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
            <info-icon size="1.5x" class="custom-class"></info-icon>
          </button>
        </div>
        <nav id="info-access-level" :style="menuStyle">
          <div style="display: block; border-top: none; text-align: left;">
            <h2>{{ $t('settings.accessLevels') }}</h2>
            <div class="subtitle">
              <eye-icon size="1.5x" class="custom-class"></eye-icon>
              <h3>{{ $t('settings.reader') }}</h3>
            </div>
            <p v-html="$t('settings.readerText')"></p>
            <div class="subtitle">
              <edit-3-icon size="1.5x" class="custom-class"></edit-3-icon>
              <h3>{{ $t('settings.editor') }}</h3>
            </div>
            <p v-html="$t('settings.editorText')"></p>
          </div>
        </nav>
      </div>
      <p v-if="isAdmin">{{ $t('settings.createLinkCollaborate') }}</p>
      <div v-if="isAdmin" class="contenedor-enlaces">
        <div :class="[isFocusEmail ? 'campo-activo' : 'campo']">
          <mail-icon size="1.5x" class="custom-class"></mail-icon>
          <input class="input input--block" type="email" v-model="emailLink" :placeholder="$t('dealers.email')" @focus="focusEmailOn" @blur="focusEmailOff">
        </div>
        <select style="margin-right: 20px; margin-left: 0;" v-model="permissions">
          <option :value=0>{{ $t('settings.editor') }}</option>
          <option :value=1>{{ $t('settings.reader') }}</option>
        </select>
        <button class="button button-create" :title="$t('buttons.createLink')" @click="crearLink" :disabled="emailLink === ''">
          <span>{{ $t('buttons.createLink') }}</span>
        </button>
      </div>
      <div class="card" v-if="arrayConcessions !== undefined">
        <div class="card-content">
          <div id="listing">
            <div class="invoicelist">
              <access-concessions v-for="(item) in arrayConcessions" :key="item.id"
                v-bind:name="item.name"
                v-bind:ctime="item.ctime"
                v-bind:handle="item.handle"
                v-bind:accesslevel="item.accesslevel"
                @revocar-acceso="revocarAcceso"
                @revocar-cuenta="revocarAccesoCuenta"> 
              </access-concessions>
            </div>
          </div>
        </div>
      </div> 
      <h2 class="access-concessions">{{ $t('settings.myAccounts') }}</h2>
      <!-- <p class="title">{{ $t('settings.createAccount') }}</p> -->
      <!-- <div class="contenedor-enlaces">
        <div :class="[isFocusCupon ? 'campo-activo' : 'campo']">
          <gift-icon size="1.5x" class="custom-class"></gift-icon>
          <input class="input input--block" type="text" v-model="coupon" :placeholder="$t('settings.optionalCoupon')" @focus="focusCuponOn" @blur="focusCuponOff">
        </div>
        <button class="button button-create" :title="$t('login.signup')" @click="crearCuenta">
          <span>{{ $t('login.signup') }}</span>
        </button>
      </div> -->
      <p class="title">{{ $t('settings.joinAccount') }}</p>
      <div class="contenedor-enlaces">
        <div :class="[isFocusLink ? 'campo-activo' : 'campo']">
          <link-icon size="1.5x" class="custom-class"></link-icon>
          <input class="input input--block" type="text" v-model="link" :placeholder="$t('settings.link')" @focus="focusLinkOn" @blur="focusLinkOff">
        </div>
        <button class="button button-create" :title="$t('settings.join')" @click="unirCuenta" :disabled="link === ''">
          <span>{{ $t('settings.join') }}</span>
        </button>
      </div>
      <div class="card" v-if="arrayAccounts !== undefined">
        <div class="card-content">
          <div id="listing">
            <div class="invoicelist">
              <accounts v-for="(item) in arrayAccounts" :key="item.id"
                v-bind:name="item.name"
                v-bind:ctime="item.ctime"
                v-bind:handle="item.handle"
                v-bind:handleCuentaDefecto="handleCuentaDefecto"
                @cuenta-defecto="anadirCuentaPorDefecto"> 
              </accounts>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { files as ibbapi } from '@/api';
import i18n from '@/i18n';
import moment from 'moment';
import * as auth from '@/utils/auth';
import { MailIcon, /*GiftIcon,*/ LinkIcon, InfoIcon, EyeIcon, Edit3Icon } from 'vue-feather-icons';
import AccessConcessions from '../../components/account/AccessConcessions.vue';
import Accounts from '../../components/account/Accounts.vue';

export default {
  name: 'settings',
  components: {
    MailIcon,
    //GiftIcon,
    LinkIcon,
    AccessConcessions,
    Accounts,
    InfoIcon,
    EyeIcon,
    Edit3Icon
  },
  data: function () {
    return {
      concessionsNumber: 0,
      isAdmin: false,
      emailAdmin: '',
      emailUser: '',
      emailLink: '',
      isRotateUser: false,
      isRotateCreate: false,
      isRotateUserCuenta: false,
      isRotateCreateCuenta: false,
      arrayConcessions: undefined,
      arrayAccounts: undefined,
      accountsNumber: 0,
      coupon: '',
      handleCuentaDefecto: '',
      handleCuenta: '',
      userName: '',
      name: '', 
      link: '',
      isFocusEmail: false,
      isFocusCupon: false,
      isFocusLink: false,
      permissions: 0,
      isShow: false,
      isButton: false
    };
  },
  async mounted () {
    try {
      let action = await ibbapi.getAccountInfo();
      this.handleCuenta = action.accountInfo.handle;
      if (action.userPermissions !== undefined) {
        this.concessionsNumber = action.userPermissions.length;
        this.arrayConcessions = action.userPermissions;
      }
      this.emailAdmin = action.email;
    } catch (e) {
      this.$showError(e);
    }

    try {
      let action = await ibbapi.getUserInfo();
      this.handleCuentaDefecto = action.accountHandle;
      if (action.accountPermissions !== undefined) {
        this.accountsNumber = action.accountPermissions.length;
        this.arrayAccounts = action.accountPermissions;
      }
      this.emailUser = action.userInfo.email;
      if (this.emailAdmin === this.emailUser) {
        this.isAdmin = true;
      }
      let userFirstname = action.userInfo.firstname;
      let userLastname = action.userInfo.lastname;
      this.name = userFirstname + ' ' + userLastname;
      this.userName = userFirstname.substr(0, 1) + userLastname.substr(0, 1);
    } catch (e) {
      this.$showError(e);
    }

    window.addEventListener('click', this.click);
  },
  beforeDestroy () {
    window.removeEventListener('click', this.click);
  },
  computed: {
    menuStyle () {
      if (this.isShow) {
        return {display: 'block'};
      } else {
        return {display: 'none'};
      }
    },
  },
  methods: {
    ...mapMutations([ 'setJoinLink', 'setCreateAccountCoupon' ]),
    focusEmailOn () {
      this.isFocusEmail = true;
    },
    focusEmailOff () {
      this.isFocusEmail = false;
    },
    focusCuponOn () {
      this.isFocusCupon = true;
    },
    focusCuponOff () {
      this.isFocusCupon = false;
    },
    focusLinkOn () {
      this.isFocusLink = true;
    },
    focusLinkOff () {
      this.isFocusLink = false;
    },
    async anadirCuentaPorDefecto (handle) {
      let action = await ibb.setDefaultAccount(handle);
      if (action.error.type) {
        throw new Error('Error setting default account: ' + action.error.type);
      } else {
        this.handleCuentaDefecto = handle;
        this.$showSuccess(this.$t('settings.defaultAccountChanged'));
      }
    },
    async revocarAcceso (handle) {
      let action = await ibb.revokeAccountAccess(handle);
      if (action.error.type) {
        throw new Error('Error revoking account access: ' + action.error.type);
      } else {
        this.$showSuccess(this.$t('settings.accessSuccessfullyRevoked'));
        try {
          let action = await ibbapi.getAccountInfo();
          if (action.userPermissions !== undefined) {
            this.concessionsNumber = action.userPermissions.length;
            this.arrayConcessions = action.userPermissions;
          }
        } catch (e) {
          this.$showError(e);
        }
      }
    },
    async revocarAccesoCuenta () {
      if (this.handleCuenta === this.handleCuentaDefecto) {
        this.$showError(this.$t('settings.revokeOwnAccess'));
      } else {
        let action = await ibb.revokeAccountAccessOfCurrentUser();
        if (action.error.type) {
          throw new Error('Error revoking account access of current user: ' + action.error.type);
        } else {
          this.$showSuccess(this.$t('settings.accessSuccessfullyRevoked'));
          if (this.arrayAccounts.length === 1) { 
            try {
              await auth.logout();
            } catch (e) {
              this.$showError(e);
            }
          } else if (this.handleCuenta !== this.handleCuentaDefecto) {
            await auth.getSessionForAccount(this.handleCuentaDefecto);
            window.history.go('/cloud');
          } 
        }
      }
    },
    humanTime: function (time) {
      return moment(time * 1000).format('DD/MM/YYYY');
    },
    async crearCuenta () {
      this.$store.commit('setCreateAccountCoupon', this.coupon);
      this.$store.commit('showHover', 'create-account');
    },
    async unirCuenta () {
      let action = await ibb.checkJoinLink(this.link, this.emailUser);
      if (action.error.type === 1 || action.error.type === 4) {
        this.$showError(i18n.t('join.emailError'));
      } else if (!action.error.type) {
        try {
          await auth.joinAccountWithCurrentUser(action.accountHandle, action.session);
          this.$showSuccess(this.$t('settings.joinAccountSuccessfully'));
        } catch (e) {
          this.$showError(e);
        }
        try {
          await auth.validateLogin();
          window.history.go('/cloud');
        } catch (e) {
          this.$showError(e);
        }
      }
    },
    async crearLink () {
      let action = await ibb.createJoinLinkWithAccessLevel(this.emailLink, this.permissions);
      if (action.error.type) {
        this.$showError(this.$t('settings.emailInvalid'));
      } else {
        this.setJoinLink(action.link);
        this.$store.commit('showHover', 'join-link');
        this.emailLink = '';
      }
    },
    async sort (by) {
      if (by === 'name') {
        if (!this.isRotateUser) { //Orden ascendente
          this.arrayConcessions = this.arrayConcessions.sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            } if (b.name < a.name ) {
              return 1;
            }  
            return 0;
          });
        } else { //Orden descendente 
          this.arrayConcessions = this.arrayConcessions.sort((a, b) => {
            if (a.name > b.name) {
              return -1;
            } if (b.name > a.name ) {
              return 1;
            }  
            return 0;
          });
        }
        this.isRotateUser = !this.isRotateUser;
      } else if (by === 'ctime') {
        if (!this.isRotateCreate) { //Orden ascendente
          this.arrayConcessions = this.arrayConcessions.sort((a, b) => {
            if (a.ctime < b.ctime) {
              return -1;
            } if (b.ctime < a.ctime ) {
              return 1;
            }  
            return 0;
          });
        } else { //Orden descendente 
          this.arrayConcessions = this.arrayConcessions.sort((a, b) => {
            if (a.ctime > b.ctime) {
              return -1;
            } if (b.ctime > a.ctime ) {
              return 1;
            }  
            return 0;
          });
        }
        this.isRotateCreate = !this.isRotateCreate;
      } 
    },
    async sortCuenta (by) {
      if (by === 'name') {
        if (!this.isRotateUserCuenta) { //Orden ascendente
          this.arrayAccounts = this.arrayAccounts.sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            } if (b.name < a.name ) {
              return 1;
            }  
            return 0;
          });
        } else { //Orden descendente 
          this.arrayAccounts = this.arrayAccounts.sort((a, b) => {
            if (a.name > b.name) {
              return -1;
            } if (b.name > a.name ) {
              return 1;
            }  
            return 0;
          });
        }
        this.isRotateUserCuenta = !this.isRotateUserCuenta;
      } else if (by === 'ctime') {
        if (!this.isRotateCreateCuenta) { //Orden ascendente
          this.arrayAccounts = this.arrayAccounts.sort((a, b) => {
            if (a.ctime < b.ctime) {
              return -1;
            } if (b.ctime < a.ctime ) {
              return 1;
            }  
            return 0;
          });
        } else { //Orden descendente 
          this.arrayAccounts = this.arrayAccounts.sort((a, b) => {
            if (a.ctime > b.ctime) {
              return -1;
            } if (b.ctime > a.ctime ) {
              return 1;
            }  
            return 0;
          });
        }
        this.isRotateCreateCuenta = !this.isRotateCreateCuenta;
      } 
    },
    mouseEnter() {
      this.isButton = true;
    },
    mouseLeave() {
      this.isButton = false;
    },
    showInfo() {
      this.isShow = !this.isShow;
    },
    click() {
      if (!this.isButton && this.isShow) {
        this.isShow = !this.isShow;
      }
    },
  }
};
</script>
